import Constants from '@/constants';

export interface Country {
  label: string;
  id: number;
}

export const countries: Country[] = [
  Constants.ADMIN_MANAGING_COUNTRIES.US,
  Constants.ADMIN_MANAGING_COUNTRIES.PR,
  Constants.ADMIN_MANAGING_COUNTRIES.CA,
  Constants.ADMIN_MANAGING_COUNTRIES.GB,
  Constants.ADMIN_MANAGING_COUNTRIES.SG,
].map(country => ({ label: country.LABEL_KEY, id: country.ID }));
